import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../../ReactQuery';
import { get } from '../../../../redux/api';
import type { GitLabSettingsResponse } from '../../../../../shared/settings/gitlab';

function fetchGitLabSettings(orgId: number) {
  return get<GitLabSettingsResponse>(`/api/organizations/${orgId}/settings/integrations/gitlab`);
}

export const getGitLabSettingsQueryKey = (orgId: number): QueryKey => ['organizations', orgId, 'settings', 'integrations', 'gitlab'];

/**
 * Fetches the GitLab settings for the organization.
 */
export default function useGetGitLabSettings(orgId: number, isEnabled: boolean) {
  return useQuery<GitLabSettingsResponse>({
    enabled: isEnabled,
    queryKey: getGitLabSettingsQueryKey(orgId),
    queryFn: () => fetchGitLabSettings(orgId),
  });
}
